/**
 * Каталог хобби для мультивыбора в онбординге.
 *
 * Уроки от хобби не зависят: истории программы интересны сами по себе.
 * Хобби остаются темами для свободной беседы с квоккой.
 *
 * Модуль не зависит от React, Express и Prisma.
 */

/** Одно хобби из каталога выбора. */
export interface Hobby {
  /** Машинный идентификатор; хранится в профиле. */
  readonly id: string;
  readonly labelRu: string;
  readonly labelEn: string;
  readonly emoji: string;
}

/**
 * Популярные хобби для мультивыбора в онбординге. Список намеренно
 * широкий и «бытовой»: пользователь узнаёт свои увлечения и отмечает
 * их, а не выбирает одну категорию из десяти.
 */
export const HOBBIES: readonly Hobby[] = [
  { id: 'movies', labelRu: 'Кино и фильмы', labelEn: 'Movies', emoji: '🎬' },
  { id: 'tv-series', labelRu: 'Сериалы', labelEn: 'TV series', emoji: '📺' },
  { id: 'music', labelRu: 'Музыка', labelEn: 'Music', emoji: '🎵' },
  { id: 'karaoke', labelRu: 'Караоке', labelEn: 'Karaoke', emoji: '🎤' },
  { id: 'reading', labelRu: 'Чтение', labelEn: 'Reading', emoji: '📚' },
  { id: 'writing', labelRu: 'Писательство', labelEn: 'Writing', emoji: '✍️' },
  { id: 'podcasts', labelRu: 'Подкасты', labelEn: 'Podcasts', emoji: '🎧' },
  { id: 'travel', labelRu: 'Путешествия', labelEn: 'Travel', emoji: '✈️' },
  { id: 'photography', labelRu: 'Фотография', labelEn: 'Photography', emoji: '📷' },
  { id: 'art', labelRu: 'Рисование', labelEn: 'Art', emoji: '🎨' },
  { id: 'dance', labelRu: 'Танцы', labelEn: 'Dance', emoji: '💃' },
  { id: 'cooking', labelRu: 'Готовка', labelEn: 'Cooking', emoji: '🍳' },
  { id: 'baking', labelRu: 'Выпечка', labelEn: 'Baking', emoji: '🧁' },
  { id: 'coffee', labelRu: 'Кофе', labelEn: 'Coffee', emoji: '☕' },
  { id: 'food', labelRu: 'Еда', labelEn: 'Food', emoji: '🍽️' },
  { id: 'gaming', labelRu: 'Видеоигры', labelEn: 'Gaming', emoji: '🎮' },
  { id: 'board-games', labelRu: 'Настольные игры', labelEn: 'Board games', emoji: '🎲' },
  { id: 'chess', labelRu: 'Шахматы', labelEn: 'Chess', emoji: '♟️' },
  { id: 'anime', labelRu: 'Аниме', labelEn: 'Anime', emoji: '🌸' },
  { id: 'comics', labelRu: 'Комиксы', labelEn: 'Comics', emoji: '💥' },
  { id: 'fitness', labelRu: 'Фитнес', labelEn: 'Fitness', emoji: '🏋️' },
  { id: 'running', labelRu: 'Бег', labelEn: 'Running', emoji: '🏃' },
  { id: 'yoga', labelRu: 'Йога', labelEn: 'Yoga', emoji: '🧘' },
  { id: 'football', labelRu: 'Футбол', labelEn: 'Football', emoji: '⚽' },
  { id: 'basketball', labelRu: 'Баскетбол', labelEn: 'Basketball', emoji: '🏀' },
  { id: 'tennis', labelRu: 'Теннис', labelEn: 'Tennis', emoji: '🎾' },
  { id: 'swimming', labelRu: 'Плавание', labelEn: 'Swimming', emoji: '🏊' },
  { id: 'cycling', labelRu: 'Велосипед', labelEn: 'Cycling', emoji: '🚴' },
  { id: 'hiking', labelRu: 'Походы', labelEn: 'Hiking', emoji: '🥾' },
  { id: 'camping', labelRu: 'Кемпинг', labelEn: 'Camping', emoji: '🏕️' },
  { id: 'fishing', labelRu: 'Рыбалка', labelEn: 'Fishing', emoji: '🎣' },
  { id: 'winter-sports', labelRu: 'Лыжи и сноуборд', labelEn: 'Winter sports', emoji: '🏂' },
  { id: 'surfing', labelRu: 'Сёрфинг', labelEn: 'Surfing', emoji: '🏄' },
  { id: 'pets', labelRu: 'Питомцы', labelEn: 'Pets', emoji: '🐾' },
  { id: 'nature', labelRu: 'Природа', labelEn: 'Nature', emoji: '🌿' },
  { id: 'gardening', labelRu: 'Садоводство', labelEn: 'Gardening', emoji: '🪴' },
  { id: 'astronomy', labelRu: 'Астрономия', labelEn: 'Astronomy', emoji: '🔭' },
  { id: 'technology', labelRu: 'Технологии', labelEn: 'Technology', emoji: '💻' },
  { id: 'cars', labelRu: 'Автомобили', labelEn: 'Cars', emoji: '🚗' },
  { id: 'fashion', labelRu: 'Мода', labelEn: 'Fashion', emoji: '👗' },
  { id: 'shopping', labelRu: 'Шопинг', labelEn: 'Shopping', emoji: '🛍️' },
  { id: 'science', labelRu: 'Наука', labelEn: 'Science', emoji: '🔬' },
  { id: 'history', labelRu: 'История', labelEn: 'History', emoji: '🏛️' },
  { id: 'languages', labelRu: 'Языки', labelEn: 'Languages', emoji: '🗣️' },
  { id: 'diy', labelRu: 'Рукоделие', labelEn: 'DIY', emoji: '🧵' },
  { id: 'volunteering', labelRu: 'Волонтёрство', labelEn: 'Volunteering', emoji: '🤝' },
];

/** Хобби по идентификатору; `null`, если такого хобби в каталоге нет. */
export function findHobby(id: string): Hobby | null {
  return HOBBIES.find((hobby) => hobby.id === id) ?? null;
}
